if (typeof FacetFiltersForm !== 'undefined') {
  FacetFiltersForm.renderProductCount = function (html) {
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');

    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const source = parsedDocument.getElementById(id);
      const target = document.getElementById(id);

      if (source && target) {
        target.innerHTML = source.innerHTML;
        target.classList.remove('loading');
      }
    });
  };
}
